/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { Skeleton } from '@coursera/cds-core';

const styles = {
  shimmerContainer: css`
    .shimmer {
      display: flex;
      flex-direction: column;
      gap: 0;
      transition: all 1s ease;
    }

    .card {
      background: var(--cds-color-emphasis-neutral-background-xweak);
      opacity: 1;
      height: 580px;
      transition: all 1s ease;
      padding: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-radius: 8px;
    }

    /* Stage 1: fade out placeholders and expand 1 box */
    .stage-1 .placeholder4,
    .stage-1 .placeholder5 {
      animation: fadeOut 1s forwards;
    }

    .stage-1 #card3 {
      animation: shrink-card 1s forwards;
    }

    .stage-1 #card1 {
      animation: expand-card 1s forwards;
    }

    .stage-1 .placeholder1 {
      animation: expand-placeholder 1s forwards;
    }

    .stage-1 .placeholder2,
    .stage-1 .placeholder3 {
      animation: expand-placeholder2 1s forwards;
    }

    .stage-0 #card1,
    .stage-0 #card2,
    .stage-0 #card4,
    .stage-1 #card2,
    .stage-1 #card4 {
      height: 0;
      opacity: 0;
      padding: 0;
    }

    .stage-1 {
      gap: 10px;
    }

    @keyframes fadeOut {
      0% {
        opacity: 1;
      }

      100% {
        opacity: 0;
        height: 0;
        width: 0;
      }
    }

    @keyframes shrink-card {
      0% {
        height: 580px;
      }

      100% {
        height: 280px;
      }
    }

    @keyframes expand-card {
      0% {
        height: 0;
      }

      100% {
        height: 280px;
      }
    }

    @keyframes expand-placeholder {
      0% {
        height: 22px;
      }

      100% {
        height: 74px;
      }
    }

    @keyframes expand-placeholder2 {
      50% {
        width: 80%;
        height: 74px;
      }

      100% {
        width: 80%;
        height: 74px;
      }
    }

    /* Stage 2: fade in other two boxes */
    .stage-2 .placeholder4,
    .stage-2 .placeholder5 {
      display: none;
    }

    .stage-2 #card1,
    .stage-2 #card3 {
      height: 280px;
      animation: shrink-card-stage2 1s forwards;
    }

    .stage-2 #card2,
    .stage-2 #card4 {
      height: 0;
      animation: expand-card-stage2 1s forwards;
    }

    .stage-2 .placeholder1 {
      height: 74px;
      animation: expand-placeholder-stage2 1s forwards;
    }

    .stage-2 .placeholder2,
    .stage-2 .placeholder3 {
      width: 80%;
      height: 74px;
      animation: expand-placeholder2-stage2 1s forwards;
    }

    .stage-2 {
      gap: 10px;
    }

    @keyframes shrink-card-stage2 {
      0% {
        height: 280px;
      }

      100% {
        height: 130px;
      }
    }

    @keyframes expand-card-stage2 {
      0% {
        height: 0;
      }

      100% {
        height: 130px;
      }
    }

    @keyframes expand-placeholder-stage2 {
      0% {
        height: 74px;
      }

      100% {
        height: 26px;
      }
    }

    @keyframes expand-placeholder2-stage2 {
      0% {
        width: 80%;
        height: 74px;
      }

      100% {
        height: 26px;
        width: 80%;
      }
    }
  `,
};
type Props = {
  stage: number;
};

const ShimmerOneCardMobile = ({ stage }: Props) => {
  return (
    <div css={styles.shimmerContainer}>
      <div className={`shimmer stage-${stage}`}>
        {[1, 2, 3, 4].map((i) => (
          <div className="card" id={`card${i}`} key={i}>
            <Skeleton className="placeholder1" variant="rect" width="50%" height={22} />
            <Skeleton className="placeholder2" variant="rect" width={36} height={36} />
            <Skeleton className="placeholder3" variant="rect" width="40%" height={74} />
            <Skeleton className="placeholder4" variant="rect" width="55%" height={110} />
            <Skeleton className="placeholder5" variant="rect" width="25%" height={60} />
            <Skeleton className="placeholder5" variant="rect" width="25%" height={60} />
            <Skeleton className="placeholder5" variant="rect" width="25%" height={60} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default ShimmerOneCardMobile;
